import getWallet from "./wallet";
import abi from "../abi/xGold.json";
import ownerAbi from "../abi/owner.json";
import busoAbi from "../abi/buso.json";
import autolp from "../abi/autolp.json";
import tokenAbi from "../abi/token.json";
import { ethers } from "ethers";

// Polygon Mainnet
const proxyContract = "0x9F82745cC80635316B3ccE488EBfc7b9f80a1451";
const ownerContract = "0xE406593Aecc2CD2320389Bc34CA227df34e01670";

// Mumbai
// export const proxyContract = "0xC66443F6a4DFe3A45c1D65f7c9797F75cc6A9df3";
// export const ownerContract = "0x1636A4EA655542B4584832ffcF96b09eB92Eb7C4";

const contractCreationBlockNumber = 36878957;

const getContract = async () => {
    const wallet = await getWallet();
    let contract = new ethers.Contract(proxyContract, abi, wallet.provider);
    if (!wallet.isReadOnly) {
        contract = contract.connect(wallet.signer);
    }
    
    return contract;
}

export const getContractCreationBlock = async () => {
    return contractCreationBlockNumber;
}

export const getTotalContractTransactions = async () => {
    try {
      const wallet = await getWallet();
      const transactionCount = await wallet.provider.getTransactionCount(proxyContract);
      console.log("transactionCount: ", transactionCount);
      return transactionCount;
    } catch (error) {
      throw new Error('Failed to retrieve total contract transactions: ' + error.message);
    }
  };

// export const getAutoLpContract = async () => {
//     const wallet = await getWallet();
//     let contract = new ethers.Contract(autoLp, autolp, wallet.provider);
//     if (!wallet.isReadOnly) {
//         contract = contract.connect(wallet.signer);
//     }
//     return contract;
// }

export const getOwnerContract = async () => {
    const wallet = await getWallet();
    let contract = new ethers.Contract(ownerContract, ownerAbi, wallet.provider);
    if (!wallet.isReadOnly) {
        contract = contract.connect(wallet.signer);
    }
    return contract;
}

const token = "0xD69071579ae36c45D63EC2D5d0E82C0a569c2cC3";

export const getTokenContract = async () => {
  const wallet = await getWallet();
  let contract = new ethers.Contract(token, tokenAbi, wallet.provider);
  if (!wallet.isReadOnly) {
      contract = contract.connect(wallet.signer);
  }
  return contract;
}


export default getContract;